<template>
  <HTableScroll
    :headers="thead"
    :rows="staffs"
    :show-placeholder="showPlaceholder"
    class="dashboard-table"
    @on-scroll-end="handleScroll"
    @on-change-sort="handleChangeSort"
  >
    <template #row="{ row }">
      <td>
        <DStaffStatus :status="row.status" />
      </td>
      <td>
        <div class="dashboard-table__staff">
          <WAvatar aria-hidden size="xsmall" :url="row.photo" />
          {{ row.name }}
        </div>
      </td>
      <td>{{ row.description }}</td>
      <td>{{ row.totalChats }}</td>
      <td>{{ row.totalChannels }}</td>
      <td>{{ row.total }}</td>
      <td>
        <WButton
          variant="secondary"
          size="small"
          @click="handleStaffSelect(row)"
        >
          Ver detalhes
        </WButton>
      </td>
    </template>
  </HTableScroll>
</template>
<script>
import { WAvatar, WButton } from '@alice-health/wonderland-vue'

import { HTableScroll } from '@/components/shared/atoms'

import { DStaffStatus } from '..'

export default {
  components: {
    DStaffStatus,
    HTableScroll,
    WButton,
    WAvatar
  },
  props: {
    staffs: {
      type: Array,
      default: () => []
    },
    showPlaceholder: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onScrollEnd', 'onChangeSort', 'onSelectStaff'],
  data() {
    return {
      thead: [
        {
          title: 'Status',
          sortBy: 'status',
          order: 'asc'
        },
        {
          title: 'Pessoa',
          sortBy: 'name',
          order: 'asc'
        },
        {
          title: 'Especialidade'
        },
        {
          title: 'Chats'
        },
        {
          title: 'Canais ativos'
        },
        {
          title: 'Total de atendimentos'
        },
        {
          title: ''
        }
      ]
    }
  },
  watch: {
    staffs(value) {
      this.toggleSort(value.length > 1)
    }
  },
  methods: {
    handleScroll() {
      this.$emit('onScrollEnd')
    },
    handleChangeSort(sort) {
      this.$emit('onChangeSort', sort)
    },
    handleStaffSelect(staff) {
      this.$emit('onSelectStaff', staff)
    },
    toggleSort(sortable) {
      this.thead[0].sortBy = sortable ? 'status' : null
      this.thead[1].sortBy = sortable ? 'name' : null
    }
  }
}
</script>
<style lang="scss" scoped>
.dashboard-table {
  max-height: 58vh;
  overflow-x: hidden;

  &__staff {
    display: flex;
    gap: var(--gl-spacing-02);
  }
}
</style>
